// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 63 ? "ImportFuncDemo" : chunkId) + "." + {"63":"3e00aea5","679":"e2ed2322","719":"f14ccf30"}[chunkId] + ".css";
};